import { useOutsideClose } from './findScope'

// 시트 탭 우클릭 메뉴 — 태그 편집(디바이스 탭)·항목 편집(인터페이스 탭)이 같이 쓴다
export interface TabMenuItem { label: string; action: () => void; danger?: boolean; disabled?: boolean }

export default function TabMenu({ x, y, items, onClose }: { x: number; y: number; items: TabMenuItem[]; onClose: () => void }) {
  const ref = useOutsideClose(onClose)
  return (
    <div ref={ref} className="fixed z-50 bg-surface border border-gray-200 rounded-lg shadow-lg py-1 text-xs min-w-[140px]"
      style={{ left: x, top: Math.max(8, y - items.length * 30 - 8) }}>
      {items.map(item => (
        <button key={item.label} disabled={item.disabled} onClick={() => { item.action(); onClose() }}
          className={`block w-full text-left px-3 py-1.5 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-transparent ${item.danger ? 'text-red-600' : 'text-gray-700'}`}>
          {item.label}
        </button>
      ))}
    </div>
  )
}
